import { defaultEnvironmentConfigs, IEnvironment } from './environment.defaults';

export const environment: IEnvironment = {
  ...defaultEnvironmentConfigs,
  appInsights: {
    cloudRole: 'dev-action-tracker-angular',
    instrumentationKey: 'b333e547-acc9-4ca1-ad70-610a395e32eb',
  },
};
